import React, { FC, useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

const MoreActionsButton: FC<{
  feedback: any;
  onEditClick: (feedbackId: number) => void;
  onDeleteClick: (feedbackId: number) => void;
  onUndeleteClick: (feedbackId: number) => void;
}> = ({ feedback, onEditClick, onDeleteClick, onUndeleteClick }) => {
  const { formatMessage } = useIntl();
  const [showExtraControls, setShowExtraControls] = useState(false);
  const toggle = useCallback(
    () => setShowExtraControls((prevState) => !prevState),
    []
  );

  const handleEditClick = useCallback(() => {
    onEditClick(feedback.id);
    setShowExtraControls(false);
  }, [feedback.id, onEditClick]);

  const handleDeleteClick = useCallback(() => {
    onDeleteClick(feedback.id);
    setShowExtraControls(false);
  }, [feedback.id, onDeleteClick]);

  const handleUndeleteClick = useCallback(() => {
    onUndeleteClick(feedback.id);
    setShowExtraControls(false);
  }, [feedback.id, onUndeleteClick]);

  const isDeleted = !!feedback.deleted_at;

  return (
    <Dropdown isOpen={showExtraControls} toggle={toggle} direction="end">
      <DropdownToggle tag="button" className="focusable-element">
        <span
          id={`more=actions-button-${feedback.id}`}
          className="btn btn-sm btn-outline-secondary p-1"
          aria-label={formatMessage({
            id: 'app.views.person.personal_objective_item.more_actions.aria_label',
            defaultMessage: 'More actions button',
          })}
          style={{
            opacity: 0.45,
          }}
        >
          <i className="fe fe-more-vertical" />
        </span>
      </DropdownToggle>
      <DropdownMenu className="pt-2 pb-2" end>
        <DropdownItem onClick={handleEditClick}>
          <i className="pe-2 fe fe-copy" />
          <FormattedMessage
            id="app.views.administration.content_administration.feedback_and_recognition_admin.page.edit_this_feedback"
            defaultMessage="Edit this feedback"
          />
        </DropdownItem>
        {!isDeleted && (
          <DropdownItem onClick={handleDeleteClick}>
            <i className="pe-2 fe fe-trash" />
            <FormattedMessage
              id="app.views.administration.content_administration.feedback_and_recognition_admin.delete"
              defaultMessage="Delete this feedback"
            />
          </DropdownItem>
        )}
        {isDeleted && (
          <DropdownItem onClick={handleUndeleteClick}>
            <i className="pe-2 fe fe-trash" />
            <FormattedMessage
              id="app.views.administration.content_administration.feedback_and_recognition_admin.undelete"
              defaultMessage="Undelete this feedback"
            />
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default React.memo(MoreActionsButton);
